import axios from 'axios';
import { store } from '../store/store';

const axiosInstance = axios.create({
    // baseURL: `http://localhost:4000/api/v1/`,
    baseURL: `https://foodhub-api2.herokuapp.com/api/v1/`,
});

axiosInstance.interceptors.request.use((config) => {
    if (store) {
        const state = store.getState();
        config.headers['x-access-token'] = state.auth.auth.idToken;
    }
    config.params = config.params || {};
    return config;
});

export default axiosInstance;
